export default __webpack_public_path__ + "static/media/emoji-point.4faedbfa.svg";